import { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {
  CoursesNavItem,
  CoursesNavTrigger,
  CoursesDropdown,
  CoursesDropdownPanel,
  CoursesDropdownAnchor,
  CoursesMobileList,
  CoursesMobileExpandButton,
  CoursesMobileTopRow,
  CoursesMobileToggle,
  CoursesMobileSubmenu,
  CoursesMobileSubAnchor,
} from "./styles";

type ResourcesNavProps = {
  variant?: "desktop" | "mobile";
  onNavigate?: () => void;
  drawerOpen?: boolean;
};

const BLOG_URL = "https://publicspeakingcoach.app/blog";

const ResourcesNav = ({
  variant = "desktop",
  onNavigate,
  drawerOpen = false,
}: ResourcesNavProps) => {
  const { t } = useTranslation();
  const [desktopOpen, setDesktopOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);

  useEffect(() => {
    if (!drawerOpen) {
      setMobileExpanded(false);
    }
  }, [drawerOpen]);

  const handleNavigate = () => {
    setDesktopOpen(false);
    setMobileExpanded(false);
    onNavigate?.();
  };

  if (variant === "mobile") {
    return (
      <CoursesMobileList>
        <CoursesMobileTopRow>
          <CoursesMobileToggle
            type="button"
            aria-expanded={mobileExpanded}
            onClick={() => setMobileExpanded((expanded) => !expanded)}
          >
            {t("resources.nav")}
          </CoursesMobileToggle>
          <CoursesMobileExpandButton
            type="button"
            aria-label={t("resources.mobile.toggle")}
            aria-expanded={mobileExpanded}
            onClick={() => setMobileExpanded((expanded) => !expanded)}
          >
            <DownOutlined />
          </CoursesMobileExpandButton>
        </CoursesMobileTopRow>
        {mobileExpanded && (
          <CoursesMobileSubmenu>
            <CoursesMobileSubAnchor href={BLOG_URL} onClick={handleNavigate}>
              {t("Blog")}
            </CoursesMobileSubAnchor>
          </CoursesMobileSubmenu>
        )}
      </CoursesMobileList>
    );
  }

  return (
    <CoursesNavItem
      onMouseEnter={() => setDesktopOpen(true)}
      onMouseLeave={() => setDesktopOpen(false)}
    >
      <CoursesNavTrigger>
        {t("resources.nav")}
        <DownOutlined aria-hidden="true" />
      </CoursesNavTrigger>
      <CoursesDropdown $open={desktopOpen}>
        <CoursesDropdownPanel>
          <CoursesDropdownAnchor href={BLOG_URL} onClick={handleNavigate}>
            {t("Blog")}
          </CoursesDropdownAnchor>
        </CoursesDropdownPanel>
      </CoursesDropdown>
    </CoursesNavItem>
  );
};

export default ResourcesNav;
